import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-miterlimit": "10",
  "stroke-width": "3",
  viewBox: "0 0 69.4 82.6"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M61.5 81.1H21c-.6 0-1-.3-1-.7v-.3l6.8-11.8c.2-.4.8-.5 1.3-.4s.8.6.5.9l-6.2 10.8H60l-6.2-10.9c-.2-.4 0-.8.6-.9.5-.2 1.1 0 1.3.4l6.8 11.9c.2.4 0 .8-.5.9h-.5ZM54.7 45.7h-23c-.5 0-.9-.3-1-.7l-1.8-6.4c-.1-.5.2-1.1.7-1.2h25.1c2 0 3.6 1.4 3.7 3.4v.2c0 2-1.4 4.8-3.7 4.8Zm-22.3-2h22.3c.9 0 1.7-1.6 1.7-2.7s-.7-1.6-1.5-1.6H31.2l1.2 4.3Z" }, null, -1),
    _createElementVNode("path", { d: "M60.1 66.7H23.4c-2.1 0-3.9-1.3-4.8-3.2-.6-.8-1-1.8-1.3-2.7L1.8 10.5c-.6-1.8-.4-3.7.4-5.4.8-1.6 2.3-2.9 4.1-3.4s3.8-.2 5.3.8c1.6 1 2.8 2.6 3.4 4.4l15.1 49.7h29.8c2.8 0 5.2 2.1 5.3 4.9 0 2.8-2.1 5.2-4.9 5.3h-.5.3ZM8.2 3.4c-.4 0-.9 0-1.3.2C5.6 4 4.6 4.9 4 6c-.6 1.2-.7 2.6-.4 3.9l15.5 50.3c.2.8.5 1.5 1 2.2l.1.2c.5 1.2 1.7 2.1 3 2.2h36.7c1.7 0 3.2-1.2 3.3-2.9s-1.2-3.2-2.9-3.3H29.4c-.5 0-.9-.3-1-.7L13.2 7.4c-.4-1.4-1.3-2.6-2.5-3.3-.8-.5-1.6-.7-2.5-.7Z" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "cabin-class"}) } }